<!--
 * @Author: 黄昱森
 * @LastEditors: Hwc
 * @Description: 窄宽布局组件
-->
<template>
  <div :class="className" :style="customStyles">
    <div :class="`lc-narrowBroad__${isReverse ? 'main' : 'side'}`">
      <slot name="side"></slot>
    </div>
    <div :class="`lc-narrowBroad__${isReverse ? 'side' : 'main'}`">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LcNarrowBroad',
  props: {
    narrowWidth: {
      type: String,
      default: '20%'
    },
    interval: {
      type: String,
      default: '20px'
    },
    hasBoundary: {
      type: Boolean,
      default: true
    },
    narrowAlignItems: {
      type: String,
      default: ''
    },
    broadAlignItems: {
      type: String,
      default: ''
    },
    // 定义窄的部分是处于左边还是右边
    isReverse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    sideSlot() {
      return this.isReverse ? 'main' : 'side';
    },
    mainSlot() {
      return this.isReverse ? 'side' : 'main';
    },
    customStyles() {
      let styleObj = {
        '--narrow-width': this.narrowWidth,
        '--interval': this.interval
      };

      if (this.narrowAlignItems !== '') {
        styleObj['--narrowAlignItems'] = this.narrowAlignItems;
      }
      if (this.broadAlignItems !== '') {
        styleObj['--broadAlignItems'] = this.broadAlignItems;
      }
      return styleObj;
    },
    className() {
      const prefix = 'lc';
      return {
        [`${prefix}-narrowBroad`]: !0,
        [`${prefix}-narrowBroad--hasBoundary`]: this.hasBoundary,
        [`${prefix}-narrowBroad--reverse`]: this.isReverse
      };
    }
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>
